import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { CreditNoteMaster_Create, CreditNoteMaster_Delete, CreditNoteMaster_ReadByTenantId, CreditNoteMaster_ReadById, CreditNoteMaster_SearchByCreditNoteNo, CreditNoteMaster_Update, CreditNoteOtherCharges_create, CreditNoteOtherCharges_delete, CreditNoteOtherCharges_readAll, CreditNoteOtherCharges_readById, CreditNoteOtherCharges_readByCreditNoteId, CreditNoteOtherCharges_update } from "src/app/GlobalVariables";
import { CreditNoteMasterCreateRequestDTO, CreditNoteMasterDeleteRequestDTO, CreditNoteMasterDTO, CreditNoteMasterList, CreditNoteMasterReadByTenantIdRequestDTO, CreditNoteMasterReadByIdRequestDTO, CreditNoteMasterSearchByCreditNoteNoRequestDTO, CreditNoteMasterUpdateRequestDTO } from "./credit-note-master.interface";
import { Observable } from "rxjs";
import { CreditNoteOtherChargesCreateRequestDTO, CreditNoteOtherChargesDeleteRequestDTO, CreditNoteOtherChargesDTO, CreditNoteOtherChargesList, CreditNoteOtherChargesReadByCreditNoteIdRequestDTO, CreditNoteOtherChargesReadByIdRequestDTO, CreditNoteOtherChargesUpdateRequestDTO } from "./creditnoteothercharges.interface";


@Injectable({
    providedIn: 'root'
})
export class CreditNoteService {

    constructor() { }
    http = inject(HttpClient)


    CreditNoteMaster_Create(data: CreditNoteMasterCreateRequestDTO): Observable<CreditNoteMasterDTO> {
        return this.http.post<CreditNoteMasterDTO>(CreditNoteMaster_Create, data)
    }

    CreditNoteMaster_Update(data: CreditNoteMasterUpdateRequestDTO): Observable<CreditNoteMasterDTO> {
        return this.http.post<CreditNoteMasterDTO>(CreditNoteMaster_Update, data)
    }

    CreditNoteMaster_Delete(data: CreditNoteMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(CreditNoteMaster_Delete, data)
    }

    CreditNoteMaster_ReadByTenantId(data: CreditNoteMasterReadByTenantIdRequestDTO): Observable<CreditNoteMasterList> {
        return this.http.post<CreditNoteMasterList>(CreditNoteMaster_ReadByTenantId, data)
    }

    CreditNoteMaster_ReadById(data: CreditNoteMasterReadByIdRequestDTO): Observable<CreditNoteMasterDTO> {
        return this.http.post<CreditNoteMasterDTO>(CreditNoteMaster_ReadById, data)
    }

    CreditNoteMaster_SearchByCreditNoteNo(data: CreditNoteMasterSearchByCreditNoteNoRequestDTO): Observable<CreditNoteMasterList> {
        return this.http.post<CreditNoteMasterList>(CreditNoteMaster_SearchByCreditNoteNo, data)
    }


    //creditNoteOther charges
    CreditNoteOtherCharges_create(data:CreditNoteOtherChargesCreateRequestDTO):Observable<CreditNoteOtherChargesDTO>{
        return this.http.post<CreditNoteOtherChargesDTO>(CreditNoteOtherCharges_create ,data)
    }
    CreditNoteOtherCharges_update(data:CreditNoteOtherChargesUpdateRequestDTO):Observable<CreditNoteOtherChargesDTO>{
        return this.http.post<CreditNoteOtherChargesDTO>(CreditNoteOtherCharges_update ,data)
    }
    CreditNoteOtherCharges_delete(data:CreditNoteOtherChargesDeleteRequestDTO):Observable<void>{
        return this.http.post<void>(CreditNoteOtherCharges_delete, data)
    }
    CreditNoteOtherCharges_readById(data:CreditNoteOtherChargesReadByIdRequestDTO):Observable<CreditNoteOtherChargesDTO>{
        return this.http.post<CreditNoteOtherChargesDTO>(CreditNoteOtherCharges_readById ,data)
    }
    CreditNoteOtherCharges_readByCreditNoteId(data:CreditNoteOtherChargesReadByCreditNoteIdRequestDTO):Observable<CreditNoteOtherChargesList>{
        return this.http.post<CreditNoteOtherChargesList>(CreditNoteOtherCharges_readByCreditNoteId ,data)
    }
    CreditNoteOtherCharges_readAll():Observable<CreditNoteOtherChargesList>{
        return this.http.get<CreditNoteOtherChargesList>(CreditNoteOtherCharges_readAll);
    }

}
